<template>
  <div id="calendar-timezone-switcher"
    v-if="hasTZ && !isSame"
  >
    <a id="calendar-timezone-local"
      :class="{'tz-selected': isLocal}"
      @click.prevent="updateDisplayTimezone(tzLocal)" href="#"
      :data-tz="tzLocal"
    >
      <span class="tz-title">Local</span>
      <span class="tz-value">
        <span class="tz-value-short">{{tzAbbreviationLocal}}</span> 
        <span class="tz-value-name">{{tzLocal}}</span>
      </span>
    </a>
    
    <span class="calendar-timezone-divider">&nbsp;</span>

    <a id="calendar-timezone-event"
      :class="{'tz-selected': isEvent}"
      @click.prevent="updateDisplayTimezone(tzEvent)" href="#"
      :data-tz="tzEvent"
    >
      <span class="tz-title">Event</span>
      <span class="tz-value">
        <span class="tz-value-short">{{tzAbbreviationEvent}}</span> 
        <span class="tz-value-name">{{tzEvent}}</span>
      </span>
    </a>

  </div>
  <div v-else 
    id="calendar-timezone-switcher">
    <div>
      <span class="tz-title">Timezone</span>
      <span class="tz-value">
        <span class="tz-value-short">{{tzAbbreviationEvent}}</span> 
        <span class="tz-value-name">{{tzEvent}}</span>
      </span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { asTimeZoneAbbreviation } from '@/utils/DateTime';

export default {
  name: "CalendarTimezoneSwitcher",
  props: {
    date: {
      type: String,
      required: true
    },
  },
  data: function() {
      return {
          tzLocal: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }
  },
  computed: {
    tzEvent() {
      return this.currentEvent ? this.currentEvent.timezone : "";
    },
    isLocal() {
      return (this.displayTZ == this.tzLocal);
    },
    isEvent() {
      return (this.displayTZ == this.tzEvent);
    },
    isSame() {
      return (this.tzLocal == this.tzEvent);
    },
    tzAbbreviationLocal() {
      console.log("Date:", this.date);
      console.log("tzLocal", this.tzLocal);
      return asTimeZoneAbbreviation(this.date, this.tzLocal);
    },
    tzAbbreviationEvent() {
      return asTimeZoneAbbreviation(this.date, this.tzEvent);
    },
    hasTZ() {
      return Boolean(this.tzEvent);
    },
    ...mapGetters({
      displayTZ: "displayTZ",
      currentEvent: 'currentEvent', 
    }),
  },
  methods: {
      updateDisplayTimezone(tz) {
        this.$store.dispatch('updateDisplayTZ', tz);
      }
  },
};
</script>
<style>
#calendar-timezone-switcher {
  display: inline-flex;
  flex-direction:row;
  font-size: 12px;
  line-height: 14px;
}
#calendar-timezone-switcher > a {
  text-decoration: none;
  color: #333;
  border-bottom: 2px solid transparent;
  padding: 2px;
}
#calendar-timezone-local {
  display: inline-block;
  text-align: right;
}
#calendar-timezone-event {
  display: inline-block;
}
#calendar-timezone-switcher .tz-title {
  display: block;
  font-weight: bold;
}
#calendar-timezone-switcher .tz-selected,
#calendar-timezone-switcher a:active,
#calendar-timezone-switcher a:hover {
  xbackground-color: #eef;
  border-bottom: 2px solid #08c;
}
.calendar-timezone-divider {
  display: inline-block;
  border-right: 2px solid #ccc;
  margin: 0 10px;
}

.tz-value-name {
  display: inline-block;
  margin-left: 5px;
}
.tz-value-name:before {
  content: '(';
}
.tz-value-name:after {
  content: ')';
}

</style>
